export enum LockedType {
	NotLocked = 0,
	LockedByCurrentUser = 1,
	LockedByOtherUser = 2,
}
